export function isRatingActive(rating) {
    return rating && rating.to === null
}
